import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
}));
const CreateAccountPersonalDetailsScreen = ({}) => {
  const classes = useStyles()
  return (
    <>src/pages/CustomerBookingCreate/6/A/CreateAccount/4/PersonalDetails/index.jsx</>
  )
}

export {CreateAccountPersonalDetailsScreen}